import { Component, OnInit } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-vehicles-list',
	templateUrl: './vehicles-list.component.html',
	styleUrls: ['./vehicles-list.component.css'],
})
export class VehiclesListComponent extends ListComponent implements OnInit {
	protected itemsBeforeDataLoad = 4;
	protected apiUrl = 'vehicles';
	tableRows = [
		{ id: 'type_name', name: 'Typ' },
		{ id: 'name', name: 'Nazwa' },
		{ id: 'busType_name', name: 'Rodzaj' },
		{ id: 'registrationNumber', name: 'Nr rej.' },
		{ id: 'status_name', name: 'Status' },
		{ id: 'confirmDate', name: 'Data zatwierdzenia' },
	];
	parameters = {
		type: [],
		busType: [],
		vehicle_status: [],
	};

	protected loadBefore() {
		this.api.get('/vehicleTypes/', (result, error) => {
			this.parameters.type = result.data;
			this.loadData();
		});
		this.api.get('/vehicleBusTypes/', (result, error) => {
			this.parameters.busType = result.data;
			this.loadData();
		});
		this.api.get('/vehicleStatuses/', (result, error) => {
			this.parameters.vehicle_status = result.data;
			this.loadData();
		});
	}

	protected convertData(data) {
		data.forEach((vehicle) => {
			const seats = vehicle.seats ? vehicle.seats : '?';
			vehicle.name = vehicle.name + ' (' + seats + ')';
			vehicle.type_name = vehicle.type.name;
			vehicle.status_name = vehicle.status.name;
		});
		return data;
	}
}
